import { configureStore, combineReducers } from '@reduxjs/toolkit';
import ipaRedux from '@invicara/ipa-core/esm_modules/IpaRedux';

// Get framework reducers from ipa-core
const frameworkReducers = ipaRedux.frameworkReducers || {};

// Combine all reducers
const rootReducer = combineReducers({
  ...frameworkReducers,
  // Add app-specific reducers here if needed
});

// Create store
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types if needed
        ignoredActions: ['your/action/type'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.handler', 'meta.arg'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
